import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";
import { BrandMark } from "@/components/marketing/Navbar";

const inputCls = "w-full bg-navy-900/60 border border-white/10 focus:border-gold outline-none px-4 py-3.5 text-white placeholder:text-mist/50 transition-colors duration-300 text-sm";

export default function RegisterPage() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await register(form.name, form.email, form.password);
      navigate("/portal");
    } catch (err) {
      setError(err.response
        ? formatApiErrorDetail(err.response?.data?.detail)
        : "Having trouble reaching the server — please wait a few seconds and try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="register-page" className="min-h-screen bg-navy-950 flex items-center justify-center px-6">
      <div className="w-full max-w-md">
        <Link to="/" data-testid="register-brand-link" className="flex justify-center mb-10"><BrandMark /></Link>
        <form onSubmit={submit} className="bg-navy-900/60 border border-gold/20 p-8 sm:p-10">
          <h1 className="font-serif text-3xl text-white mb-2">Create your account</h1>
          <p className="text-mist text-sm mb-8">Track every patent and trademark filing in one place.</p>
          {error && <p data-testid="register-error" className="text-sm text-red-400 border border-red-400/30 bg-red-400/10 px-4 py-3 mb-6">{error}</p>}
          <div className="flex flex-col gap-5">
            <input required minLength={2} data-testid="register-name-input" placeholder="Full name" value={form.name} onChange={set("name")} className={inputCls} />
            <input type="email" required data-testid="register-email-input" placeholder="Email" value={form.email} onChange={set("email")} className={inputCls} />
            <input type="password" required minLength={8} data-testid="register-password-input" placeholder="Password (min 8 characters)" value={form.password} onChange={set("password")} className={inputCls} />
            <button type="submit" disabled={loading} data-testid="register-submit-button"
              className="mt-2 px-8 py-4 bg-gold text-navy-950 font-semibold text-sm tracking-wide hover:bg-gold-light transition-colors duration-300 disabled:opacity-50">
              {loading ? "Creating account..." : "Create Account"}
            </button>
          </div>
          <p className="text-sm text-mist mt-8 text-center">
            Already registered? <Link to="/portal/login" data-testid="register-login-link" className="text-gold hover:text-gold-light">Sign in</Link>
          </p>
        </form>
      </div>
    </div>
  );
}
